<app-useractivitydetailsshared [userId]="userId" [activityId]="activityId"></app-useractivitydetailsshared>